import { invariant } from '@seen/core/invariant'
import { Assessment } from '@seen/core/models/assessments/assessment'
import { ASSESSMENT_TYPES } from '@seen/core/models/assessments/constants'
import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useAIAssistantStore } from '#src/hooks/useAIAssistantStore.ts'
import { GenericAssessmentPageComponent } from '#src/pages/shared/GenericAssessmentPageComponent.tsx'

export function ParticipantAssessmentPage(): ReactNode {
  const { assessmentId } = useParams()
  invariant(assessmentId, 'Assessment ID is required')

  const setResourceContext = useAIAssistantStore(
    (state) => state.setResourceContext
  )
  const clearResourceContext = useAIAssistantStore(
    (state) => state.clearResourceContext
  )

  useEffect(() => {
    // Assessments are Composition resources (Assessment extends
    // ExtendedComposition), so the staging target is `Composition/{id}`.
    setResourceContext(`Composition/${assessmentId}`)
  }, [assessmentId, setResourceContext])

  useEffect(() => {
    return () => {
      clearResourceContext()
    }
  }, [clearResourceContext])

  return (
    <GenericAssessmentPageComponent
      assessmentId={assessmentId}
      resourceClass={Assessment}
      typeOptions={ASSESSMENT_TYPES}
      showInlineLabels
    />
  )
}
